// Client wrappers for the SOS endpoints. The acting player_id is always
// derived server-side from the session cookie.

const TRIP_DEFAULT = 'juneau-2026';

async function jsonOrThrow(res) {
  let data;
  try {
    data = await res.json();
  } catch {
    data = {};
  }
  if (!res.ok) {
    const err = new Error(data.message || data.error || `${res.url} → ${res.status}`);
    err.status = res.status;
    err.detail = data;
    throw err;
  }
  return data;
}

export async function fetchMedical({ tripId = TRIP_DEFAULT, all = false } = {}) {
  const qs = all ? `?trip_id=${tripId}&all=1` : `?trip_id=${tripId}`;
  const res = await fetch(`/api/sos/medical${qs}`, { credentials: 'include' });
  const ct = res.headers.get('content-type') || '';
  if (!ct.includes('json')) {
    const err = new Error('api_unavailable');
    err.status = 'api_unavailable';
    throw err;
  }
  return jsonOrThrow(res);
}

export async function saveMedical({ tripId = TRIP_DEFAULT, fields }) {
  const res = await fetch('/api/sos/medical', {
    method: 'PUT',
    credentials: 'include',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ trip_id: tripId, ...fields }),
  });
  return jsonOrThrow(res);
}

export async function clearMedical({ tripId = TRIP_DEFAULT } = {}) {
  const res = await fetch(`/api/sos/medical?trip_id=${tripId}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  return jsonOrThrow(res);
}

export async function broadcastSOS({ tripId = TRIP_DEFAULT, lat, lng, accuracy, message, includeMedical }) {
  const res = await fetch('/api/sos/broadcast', {
    method: 'POST',
    credentials: 'include',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({
      trip_id: tripId,
      lat,
      lng,
      accuracy,
      message,
      include_medical: includeMedical,
    }),
  });
  return jsonOrThrow(res);
}
